import {FC} from 'react';
import {styled} from 'styled-components';

import {Palette} from '@src/theme';

interface TopBarAppProps {
  left?: React.ReactNode;
  center?: React.ReactNode;
  right?: React.ReactNode;
  children?: React.ReactNode;
}

const empty = <></>;

export const TopBarApp: FC<TopBarAppProps> = props => {
  const {left = empty, center = empty, right = empty, children} = props;
  return (
    <>
      <TopBarOuter>
        <TopBarInner>
          <Left>{left}</Left>
          <Center>{center}</Center>
          <Right>{right}</Right>
        </TopBarInner>
      </TopBarOuter>
      <Content>{children}</Content>
    </>
  );
};

TopBarApp.displayName = 'TopBarApp';

const BAR_HEIGHT = '5.5rem';

const TopBarOuter = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: calc(${BAR_HEIGHT} + env(safe-area-inset-top));
  background-color: ${Palette.secondaryColor};
  color: #ddd;
  font-size: 2rem;
`;

const TopBarInner = styled.div`
  position: absolute;
  top: env(safe-area-inset-top);
  left: 1rem;
  right: 1rem;
  height: ${BAR_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
`;

const Center = styled.div`
  width: 100%;
  text-align: center;
`;

const Right = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
`;

const Content = styled.div`
  position: fixed;
  top: calc(${BAR_HEIGHT} + env(safe-area-inset-top));
  left: 0;
  right: 0;
  bottom: 0;
`;
